// stylelint-disable declaration-no-important

@each $value in $user-selects {
  .user-select-#{$value} { user-select: $value !important; }
}
